import { useEffect, useState } from "react";

import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

export const useUsername = () => {
  const [data, setData] = useState<any[]>([]); // Set the initial state with RoleDTOS[]
  const [error, setError] = useState({
    message: "",
    status: false,
  });
  const [loading, setLoading] = useState(true);

  const getUsername = async (username: string) => {
    try {
      setLoading(true);
      const response = await ApiFetch.httpGetPublic(URLS.get.user.cognitoUsername.username(username));
      setData(response?.cognitoUsername);
      return response?.cognitoUsername;
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
      throw new Error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const values = {
    data, 
    error, 
    loading,
    getUsername
  };

  return values;
};
